<script lang="ts" setup>
  definePageMeta({
    layout: 'landing',
    availableForGuests: true,
  });

  useSchemaOrg([
    defineWebPage({
      name: 'Home Page',
    }),
  ]);
</script>

<template>
  <div class="text-center pt-4">
    <LoggedOutNewView />
  </div>
</template>
